import Paper from './component';
import mainReducer from './reducer';


export const initialState = undefined;

export const reducer = mainReducer;

export const component = Paper;
